const product = window.product;
let activeVariant = window.activeVariant;

window.variantItems = [];
window.currentTotalPrice = 0;
window.totalToPay = 0;
window.totalToPayOTP = 0;
window.sellingPlanManualOverride = false;

function escapeHtml(str) {
    return String(str ?? '').replace(/[&<>"']/g, (m) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[m]));
}

function updateCheckboxListsFromSellingPlanSelect() {
    const select = document.getElementById('sellingPlanSelect');
    if (!select) return;

    const opt = select.selectedOptions?.[0];
    const listJson = opt?.dataset?.list || '[]';

    let items = [];
    try { items = JSON.parse(listJson) || []; } catch (e) { items = []; }

    document.querySelectorAll('.list-item-description.with-subscription .checkbox-list').forEach((ul) => {
        const wrapper = ul.closest('.list-item-description.with-subscription');
        if (wrapper) wrapper.style.display = items.length ? '' : 'none';

        ul.innerHTML = '';
        items.filter(Boolean).forEach((text) => {
            const li = document.createElement('li');
            li.innerHTML = `
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.509399 4.2514L3.16148 6.57197L6.69758 0.383789" stroke="black" stroke-width="1.54704"/>
            </svg>
            ${escapeHtml(text).replace(/&lt;(\/?)(s|em)&gt;/g, '<$1$2>')}
            `;
            ul.appendChild(li);
        });
    });
}

function updateSellingPlanId() {
    const select = document.getElementById('sellingPlanSelect');
    const radio = document.querySelector('input[name="purchase_type"][value="subscription"]');

    if (!select || !radio) return;

    radio.dataset.sellingId = select.value;
}

// Frequency dropdown, acquisition-v8 behavior: at 2 boxes or fewer it is disabled
// and forced to the first option (30 days); at 3+ it unlocks but stays on the first
// option until the shopper picks a frequency themselves — then their choice sticks.
function autoSwitchSellingPlan(totalBoxes) {
    const select = document.getElementById('sellingPlanSelect');
    if (!select || select.options.length < 2) return;

    if (totalBoxes <= 2) {
        // Clearing the override here matters: dropping back from 3+ boxes must not
        // leave a manually-picked plan stuck on a disabled dropdown.
        window.sellingPlanManualOverride = false;
        select.disabled = true;
        if (select.selectedIndex !== 0) {
            select.selectedIndex = 0;
            select.dispatchEvent(new Event('change'));
        }
        return;
    }

    select.disabled = false;
    if (window.sellingPlanManualOverride) return;
    if (select.selectedIndex !== 0) {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change'));
    }
}

// Active tiered discount rate: highest tier whose quantity <= boxes.
// Falls back to the flat rate when no tiers are defined on the page.
function getTierRate(tiers, qty, fallbackRate) {
    if (!Array.isArray(tiers) || !tiers.length) return fallbackRate || 0;
    let active = tiers[0];
    tiers.forEach((t) => { if (qty >= t.quantity) active = t; });
    return active.rate;
}

document.addEventListener('DOMContentLoaded', () => {
    updateSellingPlanId();
    updateMainAtcLabels();
    updateCheckboxListsFromSellingPlanSelect();
    // Empty bundle on load = 2-or-fewer regime: dropdown starts disabled on 30 days
    autoSwitchSellingPlan(getTotalQuantityFromVariantItems());

    const select = document.getElementById('sellingPlanSelect');
    if (select) {
        select.addEventListener('change', (e) => {
        if (e.isTrusted) window.sellingPlanManualOverride = true;
        updateSellingPlanId();
        updateCheckboxListsFromSellingPlanSelect();
        });
    }
});

function formatMoneyFromCents(cents) {
    const n = Number(cents) || 0;
    return `$${(n / 100).toFixed(2)}`;
}

function getBaseUnitPriceCents() {
    const totalQty = getTotalQuantityFromVariantItems();

    if (totalQty > 0 && Number(window.currentTotalPrice) > 0) {
        return window.currentTotalPrice / totalQty;
    }

    if (typeof activeVariant?.price === 'number') return activeVariant.price;
    if (typeof product?.selected_or_first_available_variant?.price === 'number') return product.selected_or_first_available_variant.price;
    if (typeof product?.variants?.[0]?.price === 'number') return product.variants[0].price;

    return 0;
}

function updateMainAtcLabels() {
  const totalQty = getTotalQuantityFromVariantItems();
  const hasItems = totalQty > 0;

  document.querySelectorAll('.product-bundle-containers add-to-cart').forEach((btn) => {
    const label = btn.querySelector('.atc-label');
    if (!label) return;

    const priceWrap = btn.querySelector('.price-container-atc');

    if (!hasItems) {
      label.textContent = 'SELECT FLAVORS';
      if (priceWrap) priceWrap.style.display = 'none';

      btn.setAttribute('aria-disabled', 'true');
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.6';
      btn.style.cursor = 'not-allowed';
    } else {
      const wrap = btn.closest('.bundle-container-subscription, .bundle-container-otp');
      if (wrap?.classList.contains('bundle-container-subscription')) {
        label.textContent = label.dataset.settingsTitle || 'ADD TO CART';
      } else if (wrap?.classList.contains('bundle-container-otp')) {
        label.textContent = label.dataset.settingsTitle || 'TRY NOW';
      }

      if (priceWrap) priceWrap.style.display = '';

      btn.setAttribute('aria-disabled', 'false');
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
      btn.style.cursor = '';
    }
  });
}

function getTotalQuantityFromVariantItems() {
    return (window.variantItems || []).reduce((sum, it) => sum + (it.quantity || 0), 0);
}

function updatePricingUI() {
  const totalQty = getTotalQuantityFromVariantItems();
  if (totalQty === 0) return;

  const fmt = (cents) => `$${((Number(cents) || 0) / 100).toFixed(2)}`;

  const calcPerStick = (totalCents, boxQty) => {
    const sticks = (Number(boxQty) || 0) * 30;
    if (!sticks) return '$0.00 / stick';
    return `$${((Number(totalCents) || 0) / 100 / sticks).toFixed(2)} / stick`;
  };

  // Tiered %-off badges on the Sub / OTP cards follow the active tier
  const subBadge = document.getElementById('subscriptionDiscount');
  if (subBadge) subBadge.textContent = Math.round(getTierRate(window.subscriptionPromoTiers, totalQty, window.subscriptionDiscountRate) * 100) + '% Off';
  const otpBadge = document.getElementById('otpPrice');
  if (otpBadge) otpBadge.textContent = Math.round(getTierRate(window.otpPromoTiers, totalQty, window.otpDiscountRate) * 100) + '% Off';

  const wasCents = window.currentTotalPrice;
  const subNowCents = window.totalToPay;
  const otpNowCents = window.totalToPayOTP;

  // Subscription card prices
  const stickPriceWas = document.getElementById('stickPriceWas');
  const stickPriceDiscounted = document.getElementById('stickPriceDiscounted');
  if (stickPriceWas) stickPriceWas.textContent = fmt(wasCents);
  if (stickPriceDiscounted) stickPriceDiscounted.textContent = fmt(subNowCents);

  const stickPrice = document.getElementById('stickPrice');
  if (stickPrice) stickPrice.textContent = calcPerStick(subNowCents, totalQty);

  // OTP card prices
  const otpPriceWas = document.getElementById('otpPriceWas');
  const otpPriceDiscounted = document.getElementById('otpPriceDiscounted');
  if (otpPriceWas) otpPriceWas.textContent = fmt(wasCents);
  if (otpPriceDiscounted) otpPriceDiscounted.textContent = fmt(otpNowCents);

  const otpStick = document.getElementById('otpPriceStick');
  if (otpStick) otpStick.textContent = calcPerStick(otpNowCents, totalQty);

  // ATC button prices
  const subscriptionPriceWasEl = document.getElementById('subscriptionPriceWas');
  const subscriptionPriceEl = document.getElementById('subscriptionPrice');
  if (subscriptionPriceWasEl) subscriptionPriceWasEl.textContent = fmt(wasCents);
  if (subscriptionPriceEl) subscriptionPriceEl.textContent = fmt(subNowCents);

  const otpPriceWasOnlyEl = document.getElementById('otpPriceWasOnly');
  const otpPriceOnlyEl = document.getElementById('otpPriceOnly');
  if (otpPriceWasOnlyEl) otpPriceWasOnlyEl.textContent = fmt(wasCents);
  if (otpPriceOnlyEl) otpPriceOnlyEl.textContent = fmt(otpNowCents);
}

updatePricingUI();

(function () {
  const SELECTOR = '.variant-row[data-variant-id]';

  function getRow(el) {
    return el.closest(SELECTOR);
  }

  function getVariantId(row) {
    return Number(row.dataset.variantId);
  }
  function getProductPrice(row) {
    return Number(row.dataset.price);
  }

  function getQtyEl(row) {
    return row.querySelector('[data-role="qtyValue"]');
  }

  function getQty(row) {
    return Number(getQtyEl(row).textContent || 0);
  }

  function setQty(row, qty) {
    getQtyEl(row).textContent = qty;
  }

  function toggleUI(row, qty) {
    const qtySelector = row.querySelector('.qty-selector');
    const addBtn = row.querySelector('.add-to-cart-container');

    if (qty > 0) {
      qtySelector.style.display = 'inline-flex';
      addBtn.style.display = 'none';
    } else {
      qtySelector.style.display = 'none';
      addBtn.style.display = '';
    }
  }

  function updateArray(variantId, qty, productPrice) {
    const index = window.variantItems.findIndex(i => i.id === variantId);

    if (qty <= 0) {
        if (index !== -1) {
        window.variantItems.splice(index, 1);
        }
    } else {
        if (index === -1) {
        window.variantItems.push({
            id: variantId,
            quantity: qty,
            price: productPrice
        });
        } else {
        window.variantItems[index].quantity = qty;
        window.variantItems[index].price = productPrice;
        }
    }

    window.currentTotalPrice = window.variantItems.reduce((total, item) => {
        return total + (item.price * item.quantity);
    }, 0);

    const totalQuantity = window.variantItems.reduce((sum, item) => {
        return sum + item.quantity;
    }, 0);

    const appliedDiscount = getTierRate(window.subscriptionPromoTiers, totalQuantity, window.subscriptionDiscountRate);
    const appliedDiscountOTP = getTierRate(window.otpPromoTiers, totalQuantity, window.otpDiscountRate);

    window.totalToPay = window.currentTotalPrice * (1 - appliedDiscount);
    window.totalToPayOTP = window.currentTotalPrice * (1 - appliedDiscountOTP);

    autoSwitchSellingPlan(totalQuantity);
    updatePricingUI();
    updateMainAtcLabels();

    if (typeof window.syncStickyATC === 'function') {
        window.syncStickyATC();
    }
  }

  document.addEventListener('click', function (e) {
    const actionEl = e.target.closest('[data-action]');
    if (!actionEl) return;

    const row = getRow(actionEl);
    if (!row) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = getVariantId(row);
    let qty = getQty(row);

    const action = actionEl.dataset.action;

    if (action === 'add') {
      qty = 1;
    }

    if (action === 'increase') {
      qty += 1;
    }

    if (action === 'decrease') {
      qty -= 1;
    }

    qty = Math.max(0, qty);

    setQty(row, qty);
    updateArray(variantId, qty, getProductPrice(row));
    toggleUI(row, qty);

  });

  document.querySelectorAll(SELECTOR).forEach(row => {
    toggleUI(row, 0);
  });

  document.getElementById('showMoreVariants')?.addEventListener('click', function () {
    const hiddenItems = document.querySelectorAll('.productOptionItemValuesLabel[data-hidden="true"]');
    hiddenItems.forEach(item => {
      item.dataset.hidden = "false";
    });
    this.style.display = 'none';
    this.parentElement.style.display = 'none';
  });

})();

function resetBundleBuilder() {
  window.variantItems = [];
  window.currentTotalPrice = 0;
  window.totalToPay = 0;
  window.totalToPayOTP = 0;

  document.querySelectorAll('.variant-row[data-variant-id]').forEach(row => {
    const qtyEl = row.querySelector('[data-role="qtyValue"]');
    const qtySelector = row.querySelector('.qty-selector');
    const addBtn = row.querySelector('.add-to-cart-container');

    if (qtyEl) qtyEl.textContent = 0;
    if (qtySelector) qtySelector.style.display = 'none';
    if (addBtn) addBtn.style.display = '';
  });

  updateMainAtcLabels();

  if (typeof window.syncStickyATC === 'function') {
    window.syncStickyATC();
  }
}

let atcInFlight = false;

document.querySelectorAll('.product-bundle-containers add-to-cart')
  .forEach(button => {

    button.addEventListener('click', async (e) => {
      e.preventDefault();

      if (atcInFlight) return;
      atcInFlight = true;

      try {

      if (!window.variantItems || !window.variantItems.length) return;

      const wrapper = button.closest('.product-bundle-containers');
      const selectedRadio = wrapper.querySelector('input[name="purchase_type"]:checked');

      let items = window.variantItems.map(item => {
        let newItem = {
          id: item.id,
          quantity: item.quantity
        };

        if (selectedRadio.value === "subscription") {
          const sellingPlanId = selectedRadio.dataset.sellingId;
          if (sellingPlanId) {
            newItem.selling_plan = sellingPlanId;
          }
        }

        return newItem;
      });

      if (selectedRadio.value === "subscription" && typeof samplerVariantID !== 'undefined') {
        if (!cart.items.find(item => item.variant_id === samplerVariantID)) {
          items.push({ 
            quantity: 1, 
            id: samplerVariantID, 
            properties: {"_promo": "new subscription"} 
          });
        }
      }

      if (selectedRadio.value === "subscription" && selectedRadio.dataset.sellingId
          && window.gwpBottle?.enabled && window.gwpBottle.variantId) {
        try {
          const freshCart = await fetch('/cart.js').then(res => res.json());
          const existingCases = freshCart.items.reduce((sum, item) =>
            window.gwpCountsToward(item) ? sum + item.quantity : sum, 0);
          const addedCases = window.variantItems.reduce((sum, item) =>
            sum + (Number(item.quantity) || 0), 0);
          const hasBottle = freshCart.items.some(item =>
            item.id === window.gwpBottle.variantId && item.final_line_price === 0);
          if (existingCases + addedCases >= window.gwpBottle.minCases && !hasBottle) {
            items.push({ 
              id: window.gwpBottle.variantId, 
              quantity: 1, 
              properties: {"_promo": "new subscription"} 
            });
          }
        } catch (error) {
          console.warn('GWP bottle check failed, adding to cart without it:', error);
        }
      }

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (button?.dataset?.openCart === "true"){
            await openCart()
            resetBundleBuilder()
        }else{
            window.location.href = '/checkout';
        }

      } catch (error) {
        console.error('Add to cart error:', error);
      }

      } finally {
        atcInFlight = false;
      }

    });

});


(function initStickyATC() {
  if (!window.enableStickyATC) return;
  const target = document.querySelector('.product-bundle-containers');
  const sticky = document.getElementById('stickyATC');
  const variantsTarget = document.querySelector('.productOptionItemValues');
  if (!target || !sticky || !variantsTarget ) return;

  const stickyBtn = sticky.querySelector('[data-role="stickyBtn"]');
  const stickyLabel = sticky.querySelector('[data-role="stickyLabel"]');
  const stickyPricesWrap = sticky.querySelector('[data-role="stickyPrices"]');
  const stickyWas = sticky.querySelector('[data-role="stickyWas"]');
  const stickyNow = sticky.querySelector('[data-role="stickyNow"]');
  const stickyTitle = sticky.querySelector('.sticky-atc__title');

  function getSelectedPurchaseType() {
    return document.querySelector('input[name="purchase_type"]:checked')?.value || 'subscription';
  }

  function getRealATCButton() {
    const type = getSelectedPurchaseType();
    return type === 'subscription'
      ? document.querySelector('.bundle-container-subscription add-to-cart')
      : document.querySelector('.bundle-container-otp add-to-cart');
  }

  function getRealPricesText() {
    const type = getSelectedPurchaseType();

    if (type === 'subscription') {
      return {
        was: document.getElementById('subscriptionPriceWas')?.textContent?.trim() || '$0.00',
        now: document.getElementById('subscriptionPrice')?.textContent?.trim() || '$0.00'
      };
    }

    return {
      was: document.getElementById('otpPriceWasOnly')?.textContent?.trim() || '$0.00',
      now: document.getElementById('otpPriceOnly')?.textContent?.trim() || '$0.00'
    };
  }

  function getTotalQty() {
    return (window.variantItems || []).reduce((sum, it) => sum + (Number(it?.quantity) || 0), 0);
  }

  function syncSticky() {
    const totalQty = getTotalQty();
    const hasItems = totalQty > 0;

    if (stickyTitle) {
      stickyTitle.textContent = document.getElementById('productTitle')?.textContent?.trim() || stickyTitle.textContent || 'Add to cart';
    }

    const type = getSelectedPurchaseType();
    const { was, now } = getRealPricesText();

    stickyLabel.textContent = hasItems ? (type === 'subscription' ? 'ADD TO CART' : 'TRY NOW') : 'SELECT FLAVORS';

    if (hasItems) {
      stickyPricesWrap.style.display = '';
      stickyWas.textContent = was;
      stickyNow.textContent = now;
      stickyBtn.setAttribute('aria-disabled', 'false');
    } else {
      stickyPricesWrap.style.display = 'none';
      stickyBtn.setAttribute('aria-disabled', 'true');
    }
  }

  function showSticky() {
    sticky.style.display = 'block';
    sticky.setAttribute('aria-hidden', 'false');
    syncSticky();
  }

  function hideSticky() {
    sticky.style.display = 'none';
    sticky.setAttribute('aria-hidden', 'true');
  }

  stickyBtn?.addEventListener('click', () => {
    const hasItems = getTotalQty() > 0;

    if (!hasItems) {
      const variants = document.querySelector('.productOptionItemValues');
      if (variants) {
        variants.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    const realBtn = getRealATCButton();
    if (realBtn) realBtn.click();
  });

  let bundleVisible = false;
  let variantsVisible = false;

  function updateStickyVisibility() {
    if (!bundleVisible && !variantsVisible) showSticky();
    else hideSticky();
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.target === target) bundleVisible = entry.isIntersecting;
        if (entry.target === variantsTarget) variantsVisible = entry.isIntersecting;
      }
      updateStickyVisibility();
    },
    { root: null, threshold: 0.05, rootMargin: '0px 0px -80px 0px' }
  );

  io.observe(target);
  io.observe(variantsTarget);

  document.addEventListener('change', (e) => {
    if (e.target?.matches('input[name="purchase_type"], #sellingPlanSelect')) {
      syncSticky();
    }
  });

  window.syncStickyATC = syncSticky;

  syncSticky();
})();
